var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { ADD_SHIPMENT_LABEL_REQUEST, addShipmentLabelFailure, addShipmentLabelSuccess } from "../../actions";
import APIIN from "../../../utils/APIIN";
const createShipmentLabel = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        const data = action.payload;
        try {
            APIIN.post("/company/label", data)
                .then((response) => {
                console.log("API Response", response);
                resolve(response);
            })
                .catch((error) => {
                console.log("API Error", error);
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* createShipmentLabelWorker(action) {
    try {
        const data = yield call(createShipmentLabel, action);
        yield put(addShipmentLabelSuccess(data));
    }
    catch (error) {
        yield put(addShipmentLabelFailure(error));
    }
}
export function* watchCreateShipmentLabelData() {
    yield takeLatest(ADD_SHIPMENT_LABEL_REQUEST, createShipmentLabelWorker);
}
